import store from "@/common/store";
import i18n from "@/common/translations/i18n.js";

/**
 * Only for server HTTP requests. Can be invoked in other services and components.
 * */
export function serverErrorHandlingNotification(message = null) {
	if (message) {
		store.dispatch('addNotification', {type: 'error', message: message});
	} else {
		store.dispatch('addNotification', {type: 'error', message: i18n.messages[i18n.locale].notifications.serverError});
	}
}

